export enum PrintType {
    EXTENDED = 'Esteso',
    NORMAL = 'Normale',
    ONLY_FINAL = 'Solo prezzi finali',
    NO_PRICES = 'Nascondi prezzi'
}
